function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,27L179,27",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "26.07px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,27L179,27",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "26.07px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,27L179,27",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "26.07px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,27L179,27",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "26.07px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.4377aeb076d2e8aa85da74fc2fb7bda6.svg";
export { ForwardRef as ReactComponent };